/**
 * PIRATE FLEET — cartridge palette.
 *
 * Open-sea daylight aesthetic distinct from the four shipped cartridges:
 * blue-green ocean (not the gray asphalt / black void of the others), warm
 * wooden hulls, white sails. Enemies use red sails so they pop against the
 * sky-blue at a glance.
 *
 * Boarding mini-games (sword duel + artillery) flip to a side-view
 * palette: warm sunset sky + dark hull silhouettes for the duel,
 * channel-of-water + barrel obstacles for artillery.
 */

// Ocean.
export const SEA_DARK = '#1a4868';
export const SEA_MID = '#2864a0';
export const SEA_LIGHT = '#3a82c8';
export const SEA_FOAM = '#bff0ff';
export const SEA_WAKE = '#88c8e0';

// Islands.
export const ISLAND_SAND = '#e8d090';
export const ISLAND_SAND_DARK = '#a09058';
export const ISLAND_PALM = '#287028';
export const ISLAND_PALM_DARK = '#184818';
export const ISLAND_ROCK = '#806858';

// Treasure.
export const CHEST_BODY = '#a05828';
export const CHEST_BAND = '#3a3018';
export const CHEST_GOLD = '#ffea00';

// Player ship.
export const HULL_BODY = '#8a5028';
export const HULL_DARK = '#503018';
export const HULL_DECK = '#b07840';
export const SAIL_WHITE = '#f0f0e8';
export const SAIL_SHADOW = '#a0a098';
export const FLAG_BLUE = '#3aa0ff';

// Enemy ship — red sails to read as threat against the sky-blue sea.
export const ENEMY_HULL = '#603018';
export const ENEMY_HULL_DARK = '#301808';
export const ENEMY_SAIL = '#c83838';
export const ENEMY_SAIL_DARK = '#801818';
export const ENEMY_FLAG = '#1a1a24'; // jolly roger black

// Cannons + projectiles.
export const CANNON_BARREL = '#3a3a48';
export const CANNON_BALL = '#1a1a24';
export const CANNON_FLASH = '#ffea00';
export const CANNON_SMOKE = '#bfbfc8';

// Wind dial.
export const WIND_DIAL_BG = '#1a2438';
export const WIND_DIAL_RIM = '#3aa0ff';
export const WIND_DIAL_ARROW = '#ffea00';
export const WIND_DIAL_TEXT = '#7af3c8';

// HUD.
export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_HP_FULL = '#3aa0ff';
export const HUD_HP_LOW = '#ff3030';

// Mini-game shared.
export const TRANSITION_BLACK = '#0a0a14';

// Sword duel side-view.
export const DUEL_SKY = '#ff8a40';
export const DUEL_SKY_DARK = '#a04018';
export const DUEL_HORIZON = '#1a3868';
export const DUEL_DECK = '#604028';
export const DUEL_DECK_DARK = '#302010';
export const DUEL_PIRATE_PLAYER = '#3aa0ff';
export const DUEL_PIRATE_ENEMY = '#c83838';
export const DUEL_SWORD = '#e8e8f0';
export const DUEL_SWORD_GLINT = '#ffffff';
export const DUEL_CLASH_FLASH = '#ffea00';

// Artillery side-view.
export const ART_SKY = '#3a82c8';
export const ART_SKY_LIGHT = '#88c8e0';
export const ART_WATER = '#1a4868';
export const ART_BARREL = '#8a5028';
export const ART_BARREL_BAND = '#3a3018';
export const ART_TRAJECTORY_DOT = '#ffea00';
export const ART_HIT_FLASH = '#ff8030';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  SEA_MID,
  HULL_BODY,
  ENEMY_SAIL,
  CHEST_GOLD,
];
